import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import DetailsHeader from '../OffersDetails/DetailsHeader/DetailsHeader'
import { truncateText } from '../../helpers/utils';
import Gallery from '../Gallery/Gallery';
import PickupZipcode from '../OffersDetails/PickupZipcode/PickupZipcode';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
import DetailsDescription from '../OffersDetails/DetailsDescription/DetailsDescription';
import { styles } from '../AuctionForm/formStyles';
import VehicleDetailsGeneral from '../molecules/VehicleDetailsGeneral';
import Machine from '../../images/agricultural-machine.png'

const AgriculturalMachineDetails = ({ details, t, isMobile, whichFolder, }) => {
  const createdAt = (() => {
    switch (whichFolder) {
      case 'browse':
        return get(details, 'published_at');
      case 'my_bets':
        return get(details, 'updated_at');
      case 'new_bets':
        return get(details, 'updated_at');
      case 'in_realization':
        return get(details, ['details', 'contact_details', 'updated_at']);
      default:
        return null;
    }
  });

  const photos = get(details, 'photos') || [];
  const classes = useStyles()
  if (!Object.keys(details).length) {
    return null
  }

  return (
    <div className={classes.detailsLeftColumn}>
      <div className={classes.row}>
        <DetailsHeader
          score={get(details, ['vehicle', 'score'])}
          details={[
            truncateText(get(details, ['vehicle', 'brand_name']), 5, 'right'),
            truncateText(get(details, ['vehicle', 'category']), 5, 'right'),
            truncateText(get(details, ['vehicle', 'model_or_type']), 5, 'right'),
            get(details, 'hash_id'),
            createdAt()
          ]}
          createdAt={createdAt}
        />
      </div>
      <div className={classes.imageContainer}>
        <img src={Machine} />
      </div>
      <Gallery photos={photos} />
      <PickupZipcode
        translations={t('pickup_zipcode')}
        zipCode={get(details, 'zip_code')}
        pickUp={get(details, 'place')}
        countryCode={get(details, 'country_code')}
      />
      {!isMobile &&
        <VehicleDetailsGeneral
          fields={[
            { key: 'defects', value: details.vehicle.defects, positiveValues: [false], },
            { key: 'vat_deducted', value: details.vat_deducted, positiveValues: [true], }
          ]}
        />
      }

      <DetailsDescription
        fields={[
          { icon: 'accessories_description', categoryName: t('details_description.vehicle_description'),
            description: get(details, ['vehicle', 'vehicle_description']), },
          { icon: 'defects_description', categoryName: t('details_description.defects_description'),
            description: get(details, ['vehicle', 'defects_description']), iconColor: styles.colors.red, },
          get(details, 'comments')?.length
            ? { icon: 'comments', categoryName: t('details_description.comments'),
                description: get(details, 'comments'), }
            : null
        ].filter(Boolean)}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  const details = get(state, ['offerDetails', 'data']);
  return {
    isMobile: get(state, ['layout', 'isMobile']),
    details,
  };
};

const useStyles = createUseStyles({
  detailsLeftColumn: {
    paddingLeft: '15px !important',
    paddingRight: '15px !important',
    width: '58.33333333%',
    float: 'left',
  },
  row: {
    display: 'flex',
  },
  imageContainer: {
    padding: '20px',
    '& img': {
      width: '100%',
    },
  },
  '@media(max-width: 900px)': {
    detailsLeftColumn: {
      width: '100%',
    },
  },
})

AgriculturalMachineDetails.propTypes = {
  whichFolder: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  details: PropTypes.shape({
    vat_deducted: PropTypes.string,
    photos: PropTypes.arrayOf(PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      })),
    vehicle: PropTypes.shape({
      defects: PropTypes.bool,
    }),
  }).isRequired,
}

export default compose(
  withScopedTranslations('offer_details'),
  connect(mapStateToProps)
)(AgriculturalMachineDetails)
